<template>
  <div class="gp-login">
    <div class="gp-login-glow gp-login-glow--one" aria-hidden="true"></div>
    <div class="gp-login-glow gp-login-glow--two" aria-hidden="true"></div>

    <div class="gp-login-shell">
      <section class="gp-login-presentation">
        <div class="gp-login-message">
          <small>GESTÃO DE GARANTIAS LOCATÍCIAS</small>
          <h1>Uma operação mais segura, simples e conectada.</h1>
          <p>Acompanhe contratações, documentos, pagamentos e vigências em um único ambiente.</p>

          <div class="gp-login-benefits">
            <div>
              <v-icon size="19">mdi-check-circle-outline</v-icon>
              <span><strong>Gestão centralizada</strong><small>Todo o fluxo da contratação em um só lugar.</small></span>
            </div>
            <div>
              <v-icon size="19">mdi-lock-check-outline</v-icon>
              <span><strong>Acesso protegido</strong><small>Informações disponíveis conforme o seu perfil.</small></span>
            </div>
            <div>
              <v-icon size="19">mdi-chart-timeline-variant</v-icon>
              <span><strong>Visão da operação</strong><small>Indicadores e acompanhamento das etapas.</small></span>
            </div>
          </div>
        </div>

      </section>

      <section class="gp-login-access">
        <div class="gp-login-card">
          <div class="gp-login-logo-wrap">
            <img :src="logoUrl" class="gp-login-logo" :class="{ 'gp-login-logo--custom': GarUrl }"
              alt="Logo de acesso" />
          </div>

          <div class="gp-login-heading">
            <span>ÁREA SEGURA</span>
            <h2>Acesse sua conta</h2>
            <p>Informe suas credenciais para continuar.</p>
          </div>

          <v-alert v-if="showAlert" class="gp-login-alert" density="compact" :type="alertType">
            <template v-slot:title>{{ alertTitle }}</template>
            {{ alertText }}
          </v-alert>

          <form class="gp-login-form" @submit.prevent="validaUser">
            <label for="gp-login-user">Usuário</label>
            <div class="gp-login-input">
              <v-icon size="19">mdi-account-outline</v-icon>
              <input id="gp-login-user" v-model.trim="login" type="text" autocomplete="username"
                placeholder="Digite seu usuário" autofocus />
            </div>

            <label for="gp-login-password">Senha</label>
            <div class="gp-login-input">
              <v-icon size="19">mdi-lock-outline</v-icon>
              <input id="gp-login-password" v-model="senha" :type="mostrarSenha ? 'text' : 'password'"
                autocomplete="current-password" placeholder="Digite sua senha" />
              <button type="button" class="gp-login-password-toggle"
                :aria-label="mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'" @click="mostrarSenha = !mostrarSenha">
                <v-icon size="18">{{ mostrarSenha ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </button>
            </div>

            <button type="submit" class="gp-login-submit" :disabled="autenticando">
              <v-progress-circular v-if="autenticando" indeterminate size="18" width="2" />
              <v-icon v-else size="18">mdi-login</v-icon>
              {{ autenticando ? 'Acessando...' : 'Acessar plataforma' }}
            </button>
          </form>

          <div class="gp-login-security">
            <v-icon size="16">mdi-shield-lock-outline</v-icon>
            <span>Ambiente seguro e acesso individual.</span>
          </div>
        </div>
      </section>
    </div>

    <!-- Modal de Reset Senha -->
    <v-dialog v-model="dialog" persistent width="600">
      <v-card style="padding: 20px;">
        <v-card-title>
          <span class="text-h6">Reset Senha</span>
        </v-card-title>
        <v-card-text>
          <v-container>
             <div class="row">
                <div class="col-md-12 col-lg-12">
                      <label for="senha">Digite seu E-mail</label>
                      <div class="input-icon">
                        <input v-model="resetEmail" type="text" class="form-control"/>
                        <span class="input-icon-addon">
                          <i class="fa fa-envelope"></i>
                        </span>
                      </div>
                </div>
                <div class="col-md-12 col-lg-12" v-if="UserReset!='' && UserReset.length > 1" style="padding-top: 20px;">
                     <label>Para qual usuário deseja Reset de senha?</label>
                    <select  v-model="userSelectecd" class="form-select form-control">
                        <option :value=null>Selecione</option>
                        <option v-for="optionTipo in UserReset" :key="optionTipo.tpdId" 
                            :value="optionTipo">{{ optionTipo.cusNome }}</option>
                    </select>
                </div>
             </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
             <v-btn color="blue-darken-1" variant="text" @click="Cancel()" style="padding-right: 20px; text-transform:none !important;">Cancelar</v-btn>
             <a class="btn btn-primary btn-lg btn-block" style="width: 100px; padding-right: 10px;" href="#" @click="EnviaReset();">Enviar</a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { SHA256 } from 'crypto-js';
import { useRoute } from 'vue-router';

export default {
  name: 'LoginView',
  components: {
    moment,
  },
  setup() {
        const route = useRoute();
        const id = route.params.id;

        return {
            id,
        };
    },
  data: () => ({
    dialog: false,
    login: '',
    senha: '',
    User: {},
    resetEmail:'',
    UserReset:[],
    userSelectecd:null,
    templateEmail:[],
    TelasUser:[],
    DadosGarantidora: [],
    ListaMeusContratos:[],
    libera:[],
    showAlert: false, // Controle de visibilidade do alerta
    alertTitle: "", // Título do alerta
    alertText: "", // Texto do alerta
    alertType: "", // Tipo do alerta (success, warning, error, etc.)
    Garantidora:[],
    GarUrl:null,
    mostrarSenha: false,
    autenticando: false,
  }),
  computed: {
    logoUrl() {
      return this.GarUrl ? this.buildFileUrl(this.GarUrl) : '/images/logogarantepay.jpg';
    }
  },
  methods: {
    async validaUser() {
      if (this.login == '' || this.login == null) {
        this.$mensagemErro("Usuário obrigatório.")
      }
      else if (this.senha == '' || this.senha == null) {
        this.$mensagemErro("Senha obrigatória.")
      }
      else {
        if (this.autenticando) return;
        let _login = {
          Login: this.login,
          Senha: this.senha,
          Tipo: "0"
        }
        this.autenticando = true;
        try {
          const response = await axios.post(`/UsrAutenticacao/Login`, _login);
          if (response.status == 200) {
            sessionStorage.removeItem('avisoSistemaFechado');
            await this.$router.push('/Home');
          }
        } finally {
          this.autenticando = false;
        }
      }
    },
    EnviaReset() {
      if (this.resetEmail == '' || this.resetEmail == null) {
        this.$mensagemErro("Digite e-mail cadastrado.")
      }
      else {
          const param1 = this.resetEmail;
          axios.get(`/Process/UsrCadastroUsuarios/GetByEmail/${param1}`).then(response => {
                this.UserReset = response.data;  
                console.log('this.UserReset')
                console.log(this.UserReset)
                //verficar se selected do tipo de pessoa esta preenchido e filtrar o UserReset para ficar com length == 1
                if (this.UserReset.length == 1) {
                  console.log('aqui')
                  console.log(this.UserReset)
                  this.EnviaEmail(this.UserReset[0].cusNome, this.UserReset[0].cusEmail, this.UserReset[0].cusId);
                }
                else if (this.UserReset.length > 1 && this.userSelectecd != null){
                  console.log('aqui2')
                  console.log(this.userSelectecd)
                  this.EnviaEmail(this.userSelectecd.cusNome, this.userSelectecd.cusEmail, this.userSelectecd.cusId);
                }
                if (this.UserReset.length == 0) {
                  this.$mensagemErro("E-mail não cadastrado")
                }
          });
      }
    },
    Cancel(){
            //window.location.reload();
            this.$router.go(0);
    },
    EnviaEmail(_nomePara, _destinatario, _id){
              axios.get(`/Process/CadMensagensPadrao/GetAll`)
                      .then(response => {
                        this.templateEmail = response.data.filter(x=> x.mpdId == 2);
                               const encrypted = SHA256(_destinatario).toString();
                               let _dadosEmail = {
                                            nomeDe: this.$GarantePayNome,
                                            nomePara: _nomePara,
                                            assunto: 'Reset de senha - Sistema GarantePay',
                                            destinatario: _destinatario,
                                            emailResposta: this.$GarantePayEmail,
                                            textoEmail: this.templateEmail[0].mpdTexto
                                                        .replace('[NomeUsuario]',_nomePara)
                                                        .replace('[SenhaReset]', this.$GarantePayLinkAcesso + 'resetsenha/' + _id + '/' + encrypted)
                                                        .replace('[Logo]', '<center><img src="' + this.$imgURL + this.templateEmail[0].mpdUrlImagem + '" style="width: 200px;" /></center>'),
                                            listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                                        }
                                axios.post(`/Process/AdmControleSmtp/Enviamail`,_dadosEmail)
                                  .then(response => {
                                        if (response.data == 1){
                                          this.$mensagemSucesso("Link para reset de senha enviado para o seu e-mail! ");
                                          this.resetEmail = "";
                                          this.dialog = false;
                                        }
                                 });
                      });
    },
     buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/logo/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
 },
  created() { 
   if (this.id != null && this.id != ''){
         axios.get(`/logo/GetLogo/` + this.id)
          .then(response => {
              this.GarUrl = response.data.garLogo;
          });
   }

  }
}
</script>

<style scoped>
.gp-login {
  position: fixed;
  inset: 0;
  z-index: 0;
  min-width: 320px;
  overflow: auto;
  background: linear-gradient(135deg, #041432, #102a5a);
  color: #fff;
}

.gp-login::before {
  position: fixed;
  inset: 0;
  content: '';
  pointer-events: none;
  background-image: linear-gradient(rgba(255, 255, 255, .025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, .025) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: linear-gradient(to right, #000, transparent 72%);
}

.gp-login-glow {
  position: fixed;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(2px);
}

.gp-login-glow--one {
  top: -180px;
  right: -120px;
  width: 520px;
  height: 520px;
  background: radial-gradient(circle, rgba(231, 121, 0, .28), transparent 68%);
}

.gp-login-glow--two {
  bottom: -240px;
  left: 8%;
  width: 580px;
  height: 580px;
  background: radial-gradient(circle, rgba(48, 113, 211, .2), transparent 67%);
}

.gp-login-shell {
  position: relative;
  z-index: 1;
  display: grid;
  width: 100%;
  min-height: 100%;
  grid-template-columns: minmax(400px, 1.15fr) minmax(420px, .85fr);
}

.gp-login-presentation {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  padding: clamp(38px, 5vw, 72px) clamp(38px, 7vw, 104px);
}

.gp-login-message { width: min(610px, 100%); margin: auto 0; }
.gp-login-message > small { color: #f7a544; font-size: 11px; font-weight: 800; letter-spacing: .16em; }
.gp-login-message h1 {
  max-width: 590px;
  margin: 16px 0 17px;
  color: #fff;
  font-size: clamp(34px, 4vw, 55px);
  font-weight: 800;
  letter-spacing: -.045em;
  line-height: 1.06;
}
.gp-login-message > p { max-width: 555px; margin: 0; color: #bcc9dd; font-size: 16px; line-height: 1.65; }

.gp-login-benefits { display: grid; gap: 14px; margin-top: 36px; }
.gp-login-benefits > div { display: flex; align-items: flex-start; gap: 12px; }
.gp-login-benefits .v-icon { margin-top: 2px; color: #f7a544; }
.gp-login-benefits span { display: flex; flex-direction: column; }
.gp-login-benefits strong { color: #f8fafc; font-size: 13px; }
.gp-login-benefits small { margin-top: 2px; color: #96a8c2; font-size: 11px; }
.gp-login-access {
  display: grid;
  min-height: 100vh;
  padding: clamp(24px, 4vw, 64px);
  place-items: center;
  border-left: 1px solid rgba(255, 255, 255, .08);
  background: rgba(5, 21, 49, .28);
  backdrop-filter: blur(5px);
}

.gp-login-card {
  width: min(465px, 100%);
  padding: clamp(28px, 4vw, 44px);
  border: 1px solid rgba(255, 255, 255, .7);
  border-radius: 22px;
  background: #fffdf9;
  box-shadow: 0 30px 80px rgba(0, 0, 0, .32);
  color: #17223b;
}

.gp-login-logo-wrap {
  display: grid;
  min-height: 82px;
  margin-bottom: 26px;
  place-items: center;
  border: 1px solid #eee7dc;
  border-radius: 14px;
  background: #fff;
}
.gp-login-logo { display: block; width: min(255px, 84%); max-height: 66px; object-fit: contain; }
.gp-login-logo--custom { transform: translateY(7px); }

.gp-login-heading span { color: #d56c00; font-size: 9.5px; font-weight: 850; letter-spacing: .14em; }
.gp-login-heading h2 { margin: 7px 0 6px; color: #102a5a; font-size: 25px; font-weight: 800; letter-spacing: -.025em; }
.gp-login-heading p { margin: 0 0 25px; color: #748096; font-size: 12.5px; }
.gp-login-alert { margin-bottom: 18px; }

.gp-login-form { display: flex; flex-direction: column; }
.gp-login-form > label { margin: 0 0 6px; color: #435069; font-size: 11px; font-weight: 750; }
.gp-login-form > label:not(:first-child) { margin-top: 16px; }
.gp-login-input {
  display: grid;
  min-height: 47px;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 9px;
  padding: 0 13px;
  border: 1px solid #d8d2c8;
  border-radius: 10px;
  background: #fff;
  transition: border-color .15s ease, box-shadow .15s ease;
}
.gp-login-input:focus-within { border-color: #1d4f9f; box-shadow: 0 0 0 3px rgba(29, 79, 159, .11); }
.gp-login-input > .v-icon { color: #7b8799; }
.gp-login-input input { width: 100%; min-width: 0; border: 0; outline: 0; background: transparent; color: #17223b; font-size: 13px; }
.gp-login-input input::placeholder { color: #a2aab7; }
.gp-login-password-toggle { display: grid; padding: 4px; border: 0; background: transparent; color: #758197; place-items: center; }

.gp-login-submit {
  display: flex;
  min-height: 47px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, #ed820c, #d66c00);
  box-shadow: 0 12px 25px rgba(231, 121, 0, .23);
  color: #fff;
  font-size: 12.5px;
  font-weight: 800;
  transition: transform .15s ease, box-shadow .15s ease;
}
.gp-login-submit:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 15px 28px rgba(231, 121, 0, .3); }
.gp-login-submit:disabled { cursor: wait; opacity: .72; }
.gp-login-security { display: flex; align-items: center; justify-content: center; gap: 6px; margin-top: 19px; color: #8791a1; font-size: 9.5px; }
.gp-login-security .v-icon { color: #2e7d5a; }

@media (max-width: 900px) {
  .gp-login-shell { grid-template-columns: 1fr; }
  .gp-login-presentation { display: none; }
  .gp-login-access { min-height: 100%; padding: 24px; border-left: 0; }
}

@media (max-width: 520px) {
  .gp-login-access { padding: 14px; }
  .gp-login-card { padding: 25px 20px; border-radius: 17px; }
  .gp-login-logo-wrap { min-height: 72px; margin-bottom: 22px; }
  .gp-login-heading h2 { font-size: 22px; }
}
</style>
